// extracted by mini-css-extract-plugin
export default {"list-product-item--bold":"ListProductItem_list-product-item--bold__SI7Au"};